<template>
  <div class="accounting page page-with-table p-3">
    <div>
      <artisio-tabs v-model="currentTab" content-class="bg-white p-2">
        <accounting-sync-table/>
        <accounting-tab></accounting-tab>
      </artisio-tabs>
    </div>
  </div>
</template>

<script>
  import ArtisioTabs from "@/core/components/artisio-tabs/ArtisioTabs";
  import AccountingTab from "@/modules/setup/accounting/AccountingTab";
  import AccountingSyncTable from "@/modules/setup/accounting/AccountingSyncTable";

  export default {
    name: "Accounting",
    components: {AccountingSyncTable, AccountingTab, ArtisioTabs},
    data() {
      return {
        currentTab: 0,
      }
    },
    computed: {
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .accounting {
    @include list-view-wrapper;
  }

</style>

